export default __webpack_public_path__ + "static/chp-icon-2364c2ec0d00318c0987676503b8dc94.svg";